/* import __COLOCATED_TEMPLATE__ from './classification-list-modal.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { closeModal } from 'sh-www/utils/modal-controls';
import { CLASSIFICATION_TYPES } from 'sh-www/models/classification';

const CLASS_NAME = 'SH-c-admin-classification-list-modal';

class ClassificationListModal extends Component {
  @tracked currentType = this.args.model.classificationType ?? CLASSIFICATION_TYPES.TYPE_DEFAULT;
  @tracked newLabel = '';

  get className() {
    return CLASS_NAME;
  }

  get shouldShowClassificationInfo() {
    return this.args.model.classificationLabel && this.args.model.classificationCount != null;
  }

  get adminOnlyChanged() {
    return this.currentType !== this.args.model.classificationType;
  }

  get actionButtonDisabled() {
    if (this.args.model.actionType === 'Update') {
      return this.newLabel === '' && !this.adminOnlyChanged;
    }

    return this.newLabel === '' && this.args.model.actionType !== 'Delete';
  }

  get isAdminOnly() {
    return this.currentType === CLASSIFICATION_TYPES.TYPE_ADMIN_ONLY;
  }

  @action
  handleToggleAdminOnly() {
    this.currentType = this.currentType !== CLASSIFICATION_TYPES.TYPE_ADMIN_ONLY
      ? CLASSIFICATION_TYPES.TYPE_ADMIN_ONLY
      : CLASSIFICATION_TYPES.TYPE_DEFAULT;
  }

  @action
  handleUpdateLabel(value) {
    this.newLabel = value;
  }

  @action
  handleDismiss() {
    closeModal(this);
  }

  @action
  handleSave() {
    const { currentType, newLabel } = this;
    const { classificationId, category } = this.args.model;

    if (this.args.model.actionType === 'Add') {
      this.args.model.confirmAction.perform(newLabel, category, currentType);
    }

    else if (this.args.model.actionType === 'Update') {
      this.args.model.confirmAction.perform(classificationId, newLabel, currentType);
    }

    else if (this.args.model.actionType === 'Delete') {
      this.args.model.confirmAction.perform(classificationId);
    }

    closeModal(this);
  }
}

export default ClassificationListModal;

